import { render, staticRenderFns } from "./Currency.vue?vue&type=template&id=076983c0&scoped=true&"
import script from "./Currency.ts?vue&type=script&lang=ts&"
export * from "./Currency.ts?vue&type=script&lang=ts&"
import style0 from "./Currency.css?vue&type=style&index=0&id=076983c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076983c0",
  null
  
)

export default component.exports